/**
 * Auth0 Configuration
 * 
 * Reads Auth0 credentials from environment variables
 */

export interface Auth0Config {
  domain: string;
  clientId: string;
}

export function getAuth0Config(): Auth0Config {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN as string | undefined;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined;

  if (!domain || !clientId) {
    throw new Error(
      'Auth0 configuration missing. Please set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID in your .env file.'
    );
  }

  return {
    domain,
    clientId,
  };
}

/**
 * Check if Auth0 is configured
 */
export function isAuth0Configured(): boolean {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN as string | undefined;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string | undefined;
  return Boolean(domain && clientId);
}
